module.exports = __webpack_public_path__ + "static/media/favicon-32x32.d4344cb4.svg";